'use client'

import React from 'react'
import Link from 'next/link'
import { Equipment } from '@/payload-types'
import Image from 'next/image'
import { isMedia } from '@/lib/utils'
import { Button } from '@/components'

interface CardEquipmentProps {
  equipment: Equipment
}

function CardEquipment({ equipment }: Readonly<CardEquipmentProps>): React.ReactNode {
  const image = equipment.image
  const href = String(equipment.breadcrumbs?.at(-1)?.url)

  return (
    <div
      key={equipment.id}
      className="relative group flex flex-col rounded-xl border overflow-hidden hover:shadow-md transition-shadow"
    >
      {image && isMedia(image) ? (
        <figure className="relative bg-muted aspect-video w-full">
          <Image src={image.url!} alt={image.alt || equipment.title} fill objectFit="cover" />
        </figure>
      ) : null}

      <div className="flex flex-col gap-3 p-4 pb-16 flex-1">
        <h3 className="font-semibold text-base leading-tight">{equipment.title}</h3>
        {equipment.lead ? (
          <p className="text-sm text-muted-foreground line-clamp-3">{equipment.lead}</p>
        ) : null}
        {href ? (
          <Link href={href} className="absolute inset-0 flex flex-col items-start p-4">
            <Button variant="default" className="mt-auto" asChild>
              <span>En savoir plus</span>
            </Button>
          </Link>
        ) : null}
      </div>
    </div>
  )
}

export { CardEquipment, type CardEquipmentProps }
